export class BNLCategoryArticles {
	init() {
		const viewMoreButtons = document.querySelectorAll<HTMLButtonElement>(".articles-viewmore");
		viewMoreButtons.forEach(viewMoreButton => {
			viewMoreButton.addEventListener("click", async () => {
				await this.loadMore(viewMoreButton);
			});
		});
	}

	private async loadMore(button: HTMLElement) {
		const pageSize = parseInt(button.getAttribute("data-pageSize") ?? "12");
		const pageNumber = parseInt(button.getAttribute("data-pageNumber") ?? "2");
		const endpoint = button.getAttribute("data-endpoint");
		const tags = button.getAttribute("data-tags")?.split(",") ?? [];
		const hasAd = button.getAttribute("data-hasAd")?.toLowerCase() === "true";

		await fetch(`${endpoint}?pageSize=${pageSize}&pageNumber=${pageNumber}${tags.reduce((acc, tag) => {
			acc += `&tags=${encodeURIComponent(tag)}`;
			return acc;
		}, "")}&hasAd=${hasAd}`)
			.then(response => response.text())
			.then(articleHtmlString => {
				const parserElement = document.createElement("div");
				parserElement.innerHTML = articleHtmlString;
				const parsedResponseElements = Array.from(parserElement.children);
				const adBlocks = parserElement.querySelectorAll<HTMLElement>(".advertisement");
				const adSlots: any[] = [];

				parsedResponseElements.forEach(elementToAdd => {
					button.parentElement?.insertBefore(elementToAdd, button);
				});

				adBlocks.forEach(adBlock => {
					try {
						const adElement = adBlock.querySelector<HTMLElement>("[id]");

						if (!adElement) {
							return;
						}

						const adSize = adElement?.getAttribute("data-adSize");
						const adId = adElement?.id;

						if (adId) {
							const adSlot = (window as any).googletag.defineSlot("/15726702761/Desktop/brainandlife", JSON.parse(adSize ?? "[]"), adId).addService((window as any).googletag.pubads());
							(window as any).gptadslots.push(adSlot);
							adSlots.push(adSlot);

							(window as any).googletag.cmd.push(function () {
								adBlock.style.display = "";
								(window as any).googletag.display(adId);
								console.log(adSlot);
							});
						}
					} catch (error) { console.error(error); }
				});

				if (adBlocks?.length > 0) {
					(window as any).googletag.pubads().refresh();

					/* If the ad fails to load, remove the block so there isn't blank blocks all over the page. */
					// ToDo: Figure out if we want to have the ads be removed if they are not able to load an ad because WK is incompitent.
					// adSlots.forEach(adSlot => {
					// const adResponseInfo = adSlot.getResponseInformation();
					//  if (!adResponseInfo) {
					//    const adSlotId = adSlot.getSlotElementId();
					//    const adBlock = document.getElementById(adSlotId)?.parentElement;
					//    if (adBlock) {
					//      adBlock.style.display = "none";
					//      adBlock.remove();
					//    }
					//  }
					// });
				}

				button.setAttribute("data-pageNumber", (pageNumber + 1).toString());
			});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const categoryArticles = new BNLCategoryArticles();
	categoryArticles.init();
});
